import { createFileRoute } from '@tanstack/react-router'
import { Gem } from 'lucide-react'
import { z } from 'zod'
import { PlansScreen } from '@/screens/billing/SCR-160-plans'

export const Route = createFileRoute('/_app/billing/plans')({
  staticData: { screen: { id: 'SCR-160', title: 'Plans', group: 'Organisation', perm: ['billing.read', 'billing.manage'], order: 11, eyebrow: 'Billing', description: 'Compare plans and change yours. Prices are before GST.', icon: Gem } },
  validateSearch: z.object({ interval: z.enum(['month', 'year']).optional() }),
  component: function PlansRoute() {
    const { interval } = Route.useSearch()
    const navigate = Route.useNavigate()
    return <PlansScreen interval={interval ?? 'month'} onInterval={i => navigate({ search: { interval: i }, replace: true })} />
  },
})
